<template lang="pug">
.contratoSupporter
    h3.text-center CONTRATOS
    .row.g12
        select(v-model="id_contrato" style="width:222px; padding: 0 8px")
            option(value="") Nenhum
            option(v-for="c in contratos" :value="c.id") {{c.nome}}
        Button(v-if="id_contrato" @click="send" :loader="loaderb" layout="green-go" title="NOVA PENDÊNCIA" style="margin-left:8px") ADICIONAR
    .list.col.grid-12
        Loader(v-if="loader")
        template(v-else)
            .head.row
                .g3 Contrato
                .g3 Status
                .g3 Criado
                .g3 Atualizado 
                .g1 
            .line.row.ac(v-for="c of list") 
                .g3 {{c.contrato}}
                .g3 {{c.status.replace("_"," ")}}
                .g3 {{c.criado_em | date}} por
                    br 
                    | {{c.criado_por}}
                .g3 {{c.alterado_em | date}} 
                    br
                    | {{c.alterado_em ?'por':""}} {{c.alterado_por}}
                .g1.icons.row.ac.je
                    i.fa.fa-file(v-if="c.status == 'disponivel_download' || c.status=='assinado'" title="CONTRATO" @click="getContrato(c)")
                    i.fa.fa-trash(title="REMOVER" @click="remover(c)")
    <Modal :modal="modal" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";

export default {
    name: "ContratoSupporter",
    props: { id: Number },
    components: {
        Button,
        Loader, Modal
    },
    data() {
        return {
            show: false,
            loader: false,
            loaderb: false,
            form: {},
            list: [],
            contratos: [],
            dcontratos: [],
            id_contrato: "",
            modal: {
                show: false,
                title: "Assinatura Contrato Digital",
                layout: "ContratoDigital",
            }
        };
    },
    methods: {
        ...mapActions("admin", ["CONTRATO_ALTERA", "CONTRATO_LISTA", "CONTRATO_LISTA_DOUTOR", "CONTRATO_PENDENCIA", "CONTRATO_PENDENCIA_DEL"]),
        async getContrato(c) {
            this.modal.id_pendencia = c.id
            this.modal.id_doutor = this.id
            this.modal.operacao = c.operacao
            this.modal.show = true
        },
        async contratosDoutor() {
            this.loader = true
            await this.CONTRATO_LISTA_DOUTOR(this.id).then(({ data }) => this.list = data || [])
            this.loader = false
        },
        async send() {
            this.loaderb = true
            await this.CONTRATO_PENDENCIA({ id: this.id_contrato, id_doutor: this.id })
            this.contratosDoutor()
            this.loaderb = false
        },
        async remover(c) {
            if (confirm(`Deseja excluir o contrato: ${c.nome}?`)) {
                this.loaderb = true
                await this.CONTRATO_PENDENCIA_DEL({ id: c.id, id_doutor: this.id })
                this.contratosDoutor()
                this.loaderb = false
            }
        }
    },
    mounted() {
        this.CONTRATO_LISTA().then(({ data }) => this.contratos = data || [])
        this.contratosDoutor()
    },
    computed: {
        ...mapGetters("user", ["user"])
    }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.contratoSupporter
    @include page
    .new
        flex: 1
    h3
        color: $purple
        margin-top: 20px
    .list
        width: 96%
        color: $gray-1
        .line
            padding: 10px 8px
            border-radius: 6px
            &:nth-child(even)
                background: #eee
        .icons
            i
                margin-left: 12px
                font-size: 18px
                cursor: pointer
            .fa-trash:hover
                color: $red
            .fa-file:hover
                color: $purple
</style>